export const FETCH__DATAIMPORTFILES = 'FETCH__DATAIMPORTFILES';
export const FETCH__DATAIMPORTFILES__SUCCESS = 'FETCH__DATAIMPORTFILES__SUCCESS';
export const FETCH__DATAIMPORTFILES__FAIL = 'FETCH__DATAIMPORTFILES__FAIL';